import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["src", "onLoad"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["multiple"]

import { Field, useField } from 'vee-validate';
import { ref, computed } from 'vue';
import { VueDraggable } from 'vue-draggable-plus';
import { type Picture } from '@/types/photo-uploader';
import { useMQ } from '@/js/lib/helper/media-query';
import { uploadImage } from '@/js/lib/api/upload';
import FileDroppable from '@/js/components/common/ui/file-droppable.vue';
import IModal from '@/js/components/molecules/IModal.vue';
import ImageComment from './ImageComment.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'photo-uploader',
  props: /*@__PURE__*/_mergeModels({
    name: {},
    rules: { default: '' },
    hasComment: { type: Boolean },
    slotSize: { default: 1 },
    isEvent: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["loaded"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

let modalOpenPosition = 0;
const { isSp } = useMQ();
const { setErrors } = useField(props.name);
const uploading = ref(false);
const rootEl = ref<HTMLDivElement>();
const inputFileEl = ref<HTMLInputElement>();
const pictures = _useModel<Picture[]>(__props, "modelValue");
const filter = computed(() => [props.hasComment ? '[data-comment]' : undefined, '[data-delete]'].filter(Boolean).join(','));
const availablePictureSlots = computed(() => Math.max(props.slotSize - pictures.value.length, 0));
const imgLoaded = computed(() => (index: number) => pictures.value[index]?.loaded);
const openDialog = () => {
  modalOpenPosition = window.scrollY;
};
const closeDialog = () => {
  window.scrollTo(0, modalOpenPosition);
};
const uploadPictures = async (files: File[]) => {
  if (files.length === 0) {
    return;
  }
  if (files.some((file) => file.size > 104857600)) {
    setErrors('画像は10MB以内にしてください');
    return;
  }

  uploading.value = true;

  try {
    const fileDatas = await Promise.all(
      files.map(async (file) => {
        const fileData = await uploadImage(file);
        return fileData;
      }),
    );
    pictures.value = [
      ...pictures.value,
      ...(fileDatas as Picture[]).map((fileData) => {
        return {
          ...fileData,
          isShowCommentEdit: false,
          loaded: false,
        };
      }),
    ];
  } catch {
    setErrors('画像をアップロードできませんでした');
  } finally {
    uploading.value = false;
  }
};
const onPicturesChange = () => {
  const files: File[] = [...inputFileEl.value.files];
  uploadPictures(files.slice(0, availablePictureSlots.value));
};
const onFileDropped = (files: File[]) => {
  uploadPictures(files.slice(0, availablePictureSlots.value));
};
const onLoadImg = (index: number) => {
  pictures.value = pictures.value.map((picture, i) => (i === index ? { ...picture, loaded: true } : picture));
  emit('loaded');
};
const onRemovePictureClick = (index: number) => {
  pictures.value = pictures.value.filter((_picture, i) => i !== index);
};
const inputFileElClick = () => {
  inputFileEl.value.click();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl,
    class: _normalizeClass([_ctx.$style.wrapper, _ctx.slotSize > 1 ? _ctx.$style.multiple : '', _ctx.isEvent ? _ctx.$style.event : ''])
  }, [
    _createVNode(_unref(Field), {
      modelValue: pictures.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pictures).value = $event)),
      name: _ctx.name,
      rules: _ctx.rules
    }, {
      default: _withCtx(({ errors }) => [
        _createVNode(_unref(VueDraggable), {
          modelValue: pictures.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pictures).value = $event)),
          draggable: "[data-draggable]",
          filter: filter.value,
          "prevent-on-filter": false,
          delay: _unref(isSp) ? 50 : 0,
          class: _normalizeClass([_ctx.$style.photo, pictures.value.length > 0 ? _ctx.$style.hasPictures : ''])
        }, {
          default: _withCtx(() => [
            (pictures.value.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(pictures.value, (picture, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: picture.filename,
                    class: _normalizeClass(_ctx.$style.uploadedPhoto),
                    "data-draggable": ""
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.$style.uploadedPhoto)
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$style.uploadedPhotoContent, !imgLoaded.value(index) ? _ctx.$style.loading : ''])
                      }, [
                        _createElementVNode("img", {
                          src: picture.url,
                          onLoad: ($event: any) => (onLoadImg(index))
                        }, null, 40, _hoisted_1)
                      ], 2),
                      _cache[3] || (_cache[3] = _createTextVNode()),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style.deletePicture),
                        "data-delete": ""
                      }, [
                        _createElementVNode("i", {
                          class: "icon-cross1",
                          onClick: ($event: any) => (onRemovePictureClick(index))
                        }, null, 8, _hoisted_2)
                      ], 2),
                      _cache[4] || (_cache[4] = _createTextVNode()),
                      (_ctx.hasComment)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(_ctx.$style.comment),
                            "data-comment": ""
                          }, [
                            _createElementVNode("p", {
                              class: _normalizeClass(_ctx.$style.commentEdit),
                              onClick: ($event: any) => (picture.isShowCommentEdit = true)
                            }, [
                              (picture.text)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(picture.text), 1))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(_ctx.$style.commentEditDefault)
                                  }, "コメントを追加", 2))
                            ], 10, _hoisted_3),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createVNode(IModal, {
                              modelValue: picture.isShowCommentEdit,
                              "onUpdate:modelValue": ($event: any) => ((picture.isShowCommentEdit) = $event),
                              "show-close": false,
                              onOpen: openDialog,
                              onClose: closeDialog
                            }, {
                              default: _withCtx(() => [
                                _createVNode(ImageComment, {
                                  url: picture.url,
                                  text: picture.text,
                                  onCancel: ($event: any) => (picture.isShowCommentEdit = false),
                                  onSave: 
                      (comment) => {
                        picture.isShowCommentEdit = false;
                        picture.text = comment;
                      }
                    
                                }, null, 8, ["url", "text", "onCancel", "onSave"])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ], 2))
                        : _createCommentVNode("", true),
                      _cache[5] || (_cache[5] = _createTextVNode()),
                      (_ctx.slotSize > 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(_ctx.$style.uploadedPhotoIndex)
                          }, _toDisplayString(index + 1), 3))
                        : _createCommentVNode("", true)
                    ], 2)
                  ], 2))
                }), 128))
              : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createTextVNode()),
            (availablePictureSlots.value > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.$style.formElement)
                }, [
                  _createVNode(FileDroppable, { onFileDropped: onFileDropped }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$style.upload, uploading.value ? _ctx.$style.loading : '']),
                        onClick: inputFileElClick
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style.content)
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style.icon)
                          }, null, 2),
                          _cache[6] || (_cache[6] = _createTextVNode()),
                          _createElementVNode("p", {
                            class: _normalizeClass(_ctx.$style.text)
                          }, "画像を追加", 2)
                        ], 2),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("input", {
                          ref_key: "inputFileEl",
                          ref: inputFileEl,
                          type: "file",
                          accept: "image/jpeg,image/png,image/gif",
                          multiple: _ctx.slotSize > 1,
                          onChange: onPicturesChange
                        }, null, 40, _hoisted_5)
                      ], 2)
                    ]),
                    _: 1
                  })
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "filter", "delay", "class"]),
        _cache[9] || (_cache[9] = _createTextVNode()),
        (errors[0])
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(_ctx.$style.error)
            }, _toDisplayString(errors[0]), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "name", "rules"])
  ], 2))
}
}

})